import {  ADD_EXTRA_VACATION_INFORMATION } from "../../../enums/Request/request.types";

export const addExtraVacationInformationCurrentRequest = (data) => {
    return {
        type: ADD_EXTRA_VACATION_INFORMATION,
        payload: data,
    };
};
